import axios from 'axios'
import { Message, Loading } from 'element-ui';
let loading;
let loadingNum = 0; //  内存中正在请求的数量
function startLoading() {
	if (loadingNum == 0) {
		loading = Loading.service({
			lock: false,
			text: '加载中...',
			background: 'rgba(255,255,255,0.5)',
		})
	}
	loadingNum++;
}
function endLoading() { //  关闭加载动画
	loadingNum--;
	if (loadingNum <= 0) {
		loading.close();
	}
}
const service = axios.create({
	baseURL: process.env.API_ROOT,
	responseType: 'json',
	// withCredentials: true,
	timeout: 3*60 * 1000
})
service.interceptors.request.use(
	config => {
		if(config.loading){
			startLoading(); //  打开加载动画
		}
		var token = sessionStorage.getItem('token') || '';
		var headers = {"Authorization": "Bearer "+ token};
		// config.headers = {
		// 	"Authorization": "Bearer "+ token,
		// 	'Accept': 'application/json, text/plain, */*' //配置请求头
		// }
		if(config.responseType!='blob'){
			headers['Accept'] = 'application/json, text/plain, */*';
		}
		config.headers = headers;
		if(config.method=='get'){
			if(config.params&&config.params.perpage){
				config.params['limit'] = config.params.perpage;
			}
		}
		if(config.method=='post'){
			if(config.data&&config.data.perpage){
				config.data['limit'] = config.data.perpage;
			}
		}
		return config
	}, error => {
		Promise.reject(error)
	}
)
service.interceptors.response.use(
	response => {
		if(response.config.loading){
			endLoading();
		}
		if(response.config.responseType=='blob'){
			return Promise.resolve(response.data)
		}else{
			if (response.status == 200) {
				if (response.data.code == 0) {
					return Promise.resolve(response.data)
				} else if (response.data.code == -1) {
					return Promise.reject(response.data.msg)
				} else {
					return Promise.reject(response.data.msg)
				}
			}else{
				return Promise.reject()
			}
		}
	}, error => {
		if(error.response.config.loading){
			endLoading();
		}
		return Promise.reject(error.response.data.message)
	}
)
export default service



// WEBPACK FOOTER //
// ./src/utils/axios.js